"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ActionButton = _interopRequireDefault(require("./ActionButton")); // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var propTypeAction = function propTypeAction(components, key, componentName) {
  var error = '';
  components.some(function (component) {
    if (component.type.name !== _ActionButton["default"].name) {
      var givenType = typeof component.type === 'string' ? component.type : component.type.name || 'unknown';
      error = "Invalid component `".concat(givenType, "` passed to prop `actions` in `").concat(componentName, "`. Only `Alert.ActionButton` is allowed.");
      return true;
    }

    return false;
  });
  if (error) return new Error(error);
};

var _default = propTypeAction;
exports["default"] = _default;